import classNames from 'classnames';
import { isString } from 'lodash-es';
import { forwardRef } from 'react';
import styles from './index.module.less';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import { loading2 } from '@shared/assets/svg/base';

export type BaseButtonProps = {
	block?: boolean;
	disabled?: boolean;
	active?: boolean;
	// 用于支付模块取消订阅 红色按钮
	cancel?: boolean;
	loading?: boolean;
	/** height: nano-28 mini-32 small-36 medium-40 large-44 huge-48  */
	size?: 'nano' | 'mini' | 'small' | 'normal' | 'medium' | 'large' | 'huge';
	preset?:
		| 'primary'
		| 'secondary'
		| 'black'
		| 'withCancel'
		| 'link'
		| 'vip-web'
		| 'vip-h5'
		| 'plain'
		| 'text';
	innerClassName?: string;
	middleClassName?: string;
	innerStyle?: React.CSSProperties;
} & I_BaseComponentProps &
	React.HTMLAttributes<HTMLElement> &
	React.ButtonHTMLAttributes<HTMLElement> &
	React.AnchorHTMLAttributes<HTMLElement>;

export const NewBaseButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
	(props: BaseButtonProps, ref) => {
		const {
			className,
			innerClassName,
			middleClassName,
			innerStyle,
			children,
			onClick,
			disabled = false,
			block = false,
			active = false,
			loading = false,
			cancel = false,
			size = 'medium',
			preset = 'primary',
			...restProps
		} = props;

		const handleClick = (
			e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>,
		) => {
			if (loading || disabled) {
				e.preventDefault();
				return;
			}
			(onClick as React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>)?.(e);
		};

		const renderLoadingIcon = (
			<NewBaseIcon
				icon={loading2}
				size={['nano', 'mini', 'small'].includes(size) ? 16 : 20}
				className={styles.loading_animation}
			/>
		);

		const renderChildren = isString(children) ? <span>{children}</span> : children;

		return (
			<button
				ref={ref}
				onClick={handleClick}
				className={classNames({
					[styles.button]: true,
					[styles[preset]]: preset,
					[styles.disabled]: disabled,
					[styles.active]: active,
					[styles.cancel]: cancel,
					[styles.loading]: loading,
					[styles[`size_${size}`]]: true,
					[styles.block]: block,
					[className as string]: !!className,
				})}
				{...restProps}
			>
				<div className={classNames([styles.fill], [middleClassName])} />
				<span className={classNames([styles.text], [innerClassName])} style={innerStyle}>
					{loading && renderLoadingIcon}
					{renderChildren}
				</span>
			</button>
		);
	},
);
